<template>
  <v-card outlined>
    <v-row dense>
      <v-col>
        <v-card-title>
          {{ name }}
        </v-card-title>
      </v-col>
      <v-spacer class="limited-spacer"> </v-spacer>
      <v-col
        cols="auto"
        class="text-h5 my-auto mr-4"
        v-bind:style="{
          color: $coreScores.getColor(item.userRecords.completion / 10)
        }"
      >
        {{ item.userRecords.completion | no_decimal }}%
      </v-col>
    </v-row>
    <v-card-text class="pt-0">
      <trend-chart
        :trend-data="item.items"
        :color="$coreScores.getColor(item.userRecords.completion / 10)"
        :background-color="
          $coreScores.getColorBackground(item.userRecords.completion / 10)
        "
        tooltip-append="%"
        reverse
        round
      ></trend-chart>
    </v-card-text>
  </v-card>
</template>

<script>
import features from "@/helpers/mixins/features";
import TrendChart from "@/components/reporting/TrendChart";
export default {
  name: "UsageTrendCard",
  props: { item: { type: Object } },
  components: {
    TrendChart
  },
  mixins: [features],
  computed: {
    name() {
      return this.getFeatureName(this.item.featureId);
    }
  }
};
</script>
